import {FilesViewerData, FileTypeName} from "../../../../types/file.types";


export const documentsSignedButtons: Array<FilesViewerData> = [
  {
    title: 'Договор',
    key: 'SIGNED_CONTRACT'
  },
  {
    title: 'Акт',
    key: 'SIGNED_ACT'
  },
  {
    title: 'Тех. задание',
    key: 'SIGNED_TASK'
  },
  {
    title: 'Чек',
    key: 'RECEIPT'
  }
];

export const signedFileIdKeys: Array<FileTypeName> = [
  'SIGNED_CONTRACT', 'SIGNED_ACT', 'SIGNED_TASK', 'RECEIPT'
];
